import axios from 'axios'
import store from '@/store'
import RSA from '@/utils/rsa'
import AES from '@/utils/aes'
import router from '@/router'

axios.defaults.baseURL = store.state.rootUrl

axios.interceptors.request.use(config => {
  const token = store.state.userInfo.token
  if (store.state.userInfo.token && !config.headers.Authorization) {
    config.headers.Authorization = token
  }
  return config
})
axios.interceptors.response.use(function (response) {
  return response.data
})

function generateKey (num) {
  const library = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let key = ''
  for (let i = 0; i < num; i++) {
    const randomIndex = Math.floor(Math.random() * library.length)
    key += library.substring(randomIndex, randomIndex + 1)
  }
  return key
}

const HTTP = {
  async post (obj) {
    const key = generateKey(16)
    const t = new Date().getTime()
    const iv = t.toString().substr(5, 8) + t.toString().substr(0, 8)
    const d = AES.encrypt(JSON.stringify(obj.data), key, iv)
    await axios.post(obj.url, {
      d: d,
      k: RSA.encrypt(key),
      t: t
    }).then((data) => {
      if (data.code === 401) {
        router.push('/login')
      } else {
        if (obj.success) {
          obj.success(data)
        } else {
          console.log(data)
        }
      }
    }).catch((error) => {
      if (obj.fail) {
        obj.fail(error)
      } else {
        console.log(error)
      }
    })
  },
  async sync (obj) {
    const key = generateKey(16)
    const t = new Date().getTime()
    const iv = t.toString().substr(5, 8) + t.toString().substr(0, 8)
    const d = AES.encrypt(JSON.stringify(obj.data), key, iv)
    return await axios.post(obj.url, {
      d: d,
      k: RSA.encrypt(key),
      t: t
    }).catch((error) => {
      console.log(error)
      return {
        code: 400,
        msg: '接口错误！'
      }
    })
  },
  async file (obj) {
    await axios.post(obj.url, obj.data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (e) => {
        // console.dir(e)
        if (obj.progress) {
          obj.progress(e)
        }
      }
    }).then((data) => {
      obj.success(data)
    }).catch((error) => {
      if (obj.fail) {
        obj.fail(error)
      } else {
        console.log(error)
      }
    })
  },
  axios
}
export default HTTP
